// feel.ts — the single live copy of every tunable constant.
//
// feel.json is the source of truth on disk (diffable in git — "Evening 5 felt better than
// Evening 6" is recoverable). At runtime we work on a mutable structuredClone so Tweakpane can
// slider values live without a reload; effects always read from `feel`, never from the frozen
// import, so a slider drag is felt on the very next event. No magic numbers in effect code, ever.

import raw from "../feel.json";

export type Feel = typeof raw;

/** The live, mutable feel — bound to Tweakpane, read by every effect. */
export const feel: Feel = structuredClone(raw);

/** The pristine on-disk defaults, for the Tweakpane "reset" button. */
export const DEFAULT_FEEL: Feel = raw;
